module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), _vm._v(" "), (_vm.isFormLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitCRPS('yes')
      }
    }
  }, [_vm._v("Pledge Today!")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white u-btn-primary g-rounded-10 g-font-size-18",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitCRPS('remindLater')
      }
    }
  }, [_vm._v("Remind Me Later")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn bg-transparent text-danger g-font-size-16",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitCRPS('no')
      }
    }
  }, [_c('u', [_vm._v("Not Interested or Unable to Participate")])])])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "nonprofit-modal-msg"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_c('div', [_vm._v("\nAdopt-a-School Today!\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: " padding-left col-lg-11 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {}, [_c('b', [_vm._v("Adopt-a-School")]), _vm._v(" and we’ll provide free glasses for kids in need! ")]), _vm._v(" "), _c('p', {}, [_vm._v("Millions of students don't have the glasses they need because their families cannot access or afford vision care.")]), _vm._v(" "), _c('p', {}, [_vm._v("To bridge this gap, the OneSight EssilorLuxottica Foundation encourages eye doctors to enroll in Changing Life through Lenses (CLTL) to access free glasses and Adopt-a-School to provide local students the vision care they deserve.")]), _vm._v(" "), _c('p', {}, [_vm._v("You can "), _c('b', [_vm._v("Adopt-a-School")]), _vm._v(" and support your community in 3 easy steps: ")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/CLTLDay/Step1.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Click "), _c('b', [_vm._v("Pledge Today!")]), _vm._v(" below and pledge to support a local school  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/CLTLDay/Step2.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Contact a local school in need using CLTL’s Adopt-a-School resources")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/CLTLDay/Step3.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Serve students with the support of CLTL’s free glasses")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {}, [_vm._v("CLTL's Adopt-a-School resources help you partner with schools by offering: email templates to contact the schools, talking points to speak with the nurses and customizable flyers for parent referrals\n        ")]), _vm._v(" "), _c('p', {}, [_c('i', [_vm._v("Doctors who sign up for Changing Life through Lenses may be invited to join a OneSight EssilorLuxottica Foundation vision clinic!")])]), _vm._v(" "), _c('p', {}, [_vm._v("Pledge today and help a student be more and see more!")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e9e63d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e9e63d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CovidReliefModalForm.vue
// module id = 529
// module chunks = 3